import React from 'react';
import { Helmet } from 'react-helmet';

import AppWrapper from '../../components/appWrapper/appWrapper';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import { generateReviewSchema } from '../../lib/utils/generateReviewSchema';
import { CallToAction } from './components/callToAction/callToAction';
import { CardReader } from './components/cardReader/cardReader';
import { CardSummary } from './components/cardSummary/cardSummary';
import Faqs from './components/faqs/faqs';
import HeroSection from './components/heroSection/heroSection';
import { PataPayFeatures } from './components/pataPayFeatures/pataPayFeatures';
import { Pricing } from './components/pricing/pricing';

const reviews = [
  {
    body: 'Pata’s great for managing new clients, and super handy for regulars when I can’t get to the phone. I love the online booking option: It’s simple, quick, and it just works. Huge time-saver for both myself and my customers!',
    name: 'Leigh Butcher - Whitegates Grooming Parlour',
    date: '2025-05-01',
  },
  {
    body: 'Pata is brilliant because it’s so easy to set up and use! Everything is straightforward, and if you doneed help, their team is just an email away.',
    name: 'Erik Prins - Dog Behaviourist at Talk of the Dog',
    date: '2025-05-01',
  },
];

export const BusinessPataPay = () => {
  useScrollToLocation();

  const reviewSchema = generateReviewSchema(reviews);

  return (
    <>
      <Helmet>
        <title>Pata for Business | Free Booking Platform for Pet Care Businesses</title>
        <meta
          name="description"
          content="Streamline your pet business with Pata's subscription-free booking platform. Manage admin, attract new clients, and grow your business — sign up today!"
        />
        <script type="application/ld+json">{JSON.stringify(reviewSchema)}</script>
      </Helmet>
      <AppWrapper>
        <HeroSection />
        <PataPayFeatures />

        <CardReader />
        <CardSummary />

        <Pricing />

        <Faqs />

        <CallToAction />
      </AppWrapper>
    </>
  );
};
